import styled from 'styled-components'
import { backgroundGreen, black, textMuted } from '@/theme/colors'
import { fontMono } from '@/theme/fonts'
import { radii, media } from '@/theme/tokens'
import { fontSizes, text } from '@/theme/typography'
import { cardSurface, liftOnHover } from '@components/Card'

/** The whole card is the control, so it takes the lift (ADR 0008). */
export const TripCardContainer = styled.div`
	${cardSurface}
	${liftOnHover}
	display: flex;
	flex-direction: column;
	justify-content: center;
	gap: 16px;
	height: 100%;
	min-height: 180px;

	${media.phone} {
		padding: 20px 16px;
		min-height: auto;
	}
`

export const TripCardHeader = styled.div`
	display: flex;
	flex-direction: column;
	gap: 12px;
	align-items: center;
	text-align: center;
`

/** A long name wraps inside the card; an unbroken one breaks mid-word rather than overflowing. */
export const TripTitle = styled.h3`
	${text.title}
	color: ${black};
	margin: 0;
	text-align: center;
	max-width: 100%;
	overflow-wrap: anywhere;
`

export const TripCodeContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 8px;
	justify-content: center;
`

export const TripCodeLabel = styled.span`
	font-size: ${fontSizes.small};
	font-weight: 500;
	color: ${textMuted};
`

export const TripCode = styled.span`
	background: ${backgroundGreen};
	color: ${black};
	padding: 4px 12px;
	border-radius: ${radii.small};
	font-family: ${fontMono};
	font-size: ${fontSizes.small};
	font-weight: 700;
`
